import React, { PropsWithChildren } from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { logPageBuilderError } from "@brexhq/next/src/telemetry/logging";
import { BodyL, BodyS } from "@brexhq/shared/components/Typography/Components";
import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

import { GridWidth } from "../shared/Grid";

export default class PageBuilderErrorBoundary extends React.Component<
  PropsWithChildren<{
    componentType: string;
  }>
> {
  state: {
    error?: Error;
  } = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    logPageBuilderError(error);
  }

  renderError(error: Error, componentType: string) {
    return (
      <GridWidth>
        <Container
          padding={{
            LRG: ["xlrg", 0],
            MED: ["lrg", 0],
            SML: ["med", 0],
          }}
          style={{
            background: "rgba(255, 0, 0, .35)",
          }}
        >
          <Container
            display="flex"
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <BodyL>Error in {componentType}</BodyL>
            <BodyS>{error.message}</BodyS>
          </Container>
        </Container>
      </GridWidth>
    );
  }

  render() {
    const { componentType, children } = this.props;
    const { error } = this.state;

    if (error) {
      return isDev ? this.renderError(error, componentType) : null;
    } else {
      return children;
    }
  }
}
